import UIButton from 'UIComponents/button/UIButton';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import DisabledAlertBase from './DisabledAlertBase';
import { useGetChannelName } from '../../hooks/useGetChannelName';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledAlertDuplicateThread = ({
  message,
  newestThreadId
}) => {
  const genericChannelId = getGenericChannelId(message);
  const channelName = useGetChannelName(genericChannelId);
  return /*#__PURE__*/_jsx(DisabledAlertBase, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.capability-editor.disabled-editor.duplicateThread",
      options: {
        channelName
      }
    }),
    type: 'warning',
    button: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      href: `./${newestThreadId}`,
      "data-test-id": "disabled-editor-duplicate-thread",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.capability-editor.disabled-editor.viewConversation"
      })
    })
  });
};
DisabledAlertDuplicateThread.displayName = 'DisabledAlertDuplicateThread';
export default DisabledAlertDuplicateThread;